@if (osUpdateStatus !== null && osUpdateStatus !== undefined) {
<div id="osupdate-panel"
     class="bg-white border m-2 pt-3 px-3 d-flex flex-column shadow-sm">
  <div class="border-bottom pb-1">
    <strong class="text-primary">OS update status</strong>
  </div>
  <div class="row">
    <div class="col small pt-2">
      <strong>State</strong>
    </div>
    <div class="col-auto small pt-2">
      {{ osUpdateStatus.state }}
    </div>
  </div>
  @if (osUpdateStatus.state !== osUpdateStatusState.None) {
  <div id="osupdatedownload-panel"
       class="row">
    <div class="col small pt-2">
      <strong>Download Percent Complete</strong>
    </div>
    <div class="col-auto small pt-2">
      {{ osUpdateStatus.downloadPercentComplete }}
    </div>
  </div>
  <div id="osupdatedetails-panel"
       class="row">
    <div class="col small pt-2">
      <strong>OS Update</strong>
    </div>
    <div class="col-auto small pt-2">
      {{ osUpdateStatus.osUpdate?.humanReadableName }}
    </div>
  </div>
  }
  <div class="pb-2"></div>
  <era-device-os-update-action-bar></era-device-os-update-action-bar>
</div>
}